import PropTypes from 'prop-types';

export const FormPage = ({ columns }) => (
    <div className="sds_form-page">
        {columns.map((col) => (
            <div key={col.key} className="sds_form-page__column">
                {col}
            </div>
        ))}
    </div>
);

FormPage.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.node).isRequired,
};
